import type { ReactElement } from "react";
import { getEditRecordUrl } from "../../../../utils";

interface RecordLinkProps {
  recordId?: string;
  solutionId?: string;
  applicationId?: string;
}

export const RecordLink = ({
  recordId,
  solutionId,
  applicationId,
}: RecordLinkProps): ReactElement => {
  if (recordId === undefined) {
    return <></>;
  }

  return (
    <a
      href={getEditRecordUrl(recordId, solutionId, applicationId)}
      target="_blank"
      rel="noreferrer"
    >
      {recordId}
    </a>
  );
};
